import { store } from "../store";

export const setSellerReg = (payload) => {
  return async (dispatch) => {
    await dispatch({
      type: "SET_SELLER_REG",
      payload,
    });
  };
};

export const setSellerReg2 = (payload) => {
  return async (dispatch) => {
    await dispatch({
      type: "SET_SELLER_REG2",
      payload,
    });
  };
};

export const getSellerReg = () => {
  return {
    type: "GET_SELLER_REG",
    payload: store.getState(),
  };
};
